// Dependencies
import { useTranslation } from 'react-i18next';
import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
// Icons
import Check from '@mui/icons-material/Check';
// Actions
import { setCurrentLocale } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { LanguageLocalized } from '../language/objects/language';
import { Locale } from './objects/locale';

type LocaleSelectorProps = {
    id: string,
    values: {[index: string]: any},
    all_languages?: boolean,
    size?: 'small' | 'medium',
    disabled?: boolean
}

const LocaleSelector: FC<LocaleSelectorProps> = ({id, values, size, disabled, all_languages}): ReactElement => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [locales, setLocales] = useState<Locale[]>([]);
    const locales_activated = useSelector((state: AppState) => state.locale.list);
    const locales_list = useSelector((state: AppState) => state.locale.locales_list);
    const current_locale = useSelector((state: AppState) => state.locale.current_locale);
    const onCurrentLocaleChange = (event: { target: { value: any; }; }) => {
        dispatch(setCurrentLocale(event.target.value));
    };

    const getTranslatedLangage = (locales: LanguageLocalized[], default_text: string) => {
        const value = locales.find((locale) => locale.localeTranslate === current_locale);
        return value?.translated_name && value?.translated_name !== '' ? value?.translated_name : default_text;
    };
    const onRenderValue = () => {
        if (current_locale !== null && locales) {
            for (let i = 0; i < locales.length; i++) {
                if (locales[i].id === current_locale) {
                    return getTranslatedLangage(locales[i].LocalTranslation, locales[i].full_name);
                }
            }
        }
        return '';
    };
    useEffect(() => {
        if (all_languages && locales_list) {
            setLocales(locales_list);
        }
        if (!all_languages && locales_activated) {
            setLocales(locales_activated);
        }
    }, [locales_activated, locales_list, all_languages]);
    const value = current_locale === null ? '' : current_locale;
    const displayed_value = value !== '' && locales?.find(locale => locale.id === value) ? value : '';
    return (
        <FormControl fullWidth size={size} disabled={disabled}>
            <InputLabel id={`${id}-locale`} size={size === "medium" ? "normal" : size}>{t('shared.language')}</InputLabel>
            <Select size={size} disabled={disabled} labelId={`${id}-locale`} label={t('shared.language')} value={displayed_value} onChange={onCurrentLocaleChange} renderValue={onRenderValue}>
                {locales?.map((locale) => <MenuItem key={`${id}-locale-${locale.id}`} value={locale.id}>{getTranslatedLangage(locale.LocalTranslation, locale.full_name)}{!!values[locale.id] && <Check className={'ft-locale-check'} fontSize={'small'} />}</MenuItem>)}
            </Select>
        </FormControl>
    );
};

export default LocaleSelector;